import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { inject, Injectable } from '@angular/core';
import { UserService } from '../../data/user/user.service';
import { ToasterService } from '../../api/toaster.service';

@Injectable({
  providedIn: 'root',
})
class AdminGuardService {
  constructor(
    private userService: UserService,
    private toasterService: ToasterService,
    private router: Router
  ) {}

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    try {
      await this.userService.getCurrentUserProfile();
      if (this.userService.userHasPlatformAdminRole) {
        return true;
      } else {
        this.toasterService.error('No access');
        return this.router.parseUrl('/no-access');
      }
    } catch {
      this.toasterService.error('No access');
      return this.router.parseUrl('/no-access');
    }
  }
}

export const AdminGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(AdminGuardService).canActivate(next, state);
};
